"use strict";

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = exports.createStylesHook = void 0;

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.set.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.get-own-property-names.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.map.js");

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var createStylesHook = function createStylesHook() {
  return function (styles, options) {
    return (0, _styles.makeStyles)(styles, options);
  };
};
/**
 * Merge classes helper
 * There is a good reason for this utility: eventhough classes mergin can be done natively with MUI
 * useStyles hooks (created by makeStyles utility), they can be problematic. Let's explain it:
 *
 * The traditional way of merging classes from the outter consumer with inner custom clasess was by
 * passing them as props in useStyles and let MUI do the merge:
 *
 * const useStyles = makeStyles({
 *   root: {
 *     backgroundColor: 'white',
 *   }
 * })
 *
 * interface MyComponentProps {
 *   classes?: Partial<ClassKeyMap<'root' | 'text'>>;
 * }
 *
 * const MyComponent: React.FC<MyComponentProps> = ({classes, ...rest}) => {
 *   const mergedClasses = useSyles({classes});
 *   return <MUIComponent classes={mergedClasses} {...rest}/>
 * }
 *
 * However, if outter classes brings a new classkey not present in innerClasses (e.g.: 'text')
 * merge will throw an error**. This operation should be legit in our use case, but native merge was
 * designed to only cover MUI classkeys and thus warns against foreign classkeys.
 *
 * **NOTE: These errors only appear IN DEVELOPMENT ENVIRONMENT. It won't appear at PRODUCTION, but it
 * adds a lot of noise in the console while developing and make other important errors get lost among
 * so many red lines.
 */


exports.createStylesHook = createStylesHook;

var mergeClasses = function mergeClasses() {
  for (var _len = arguments.length, classesArgs = new Array(_len), _key = 0; _key < _len; _key++) {
    classesArgs[_key] = arguments[_key];
  }

  var keySet = new Set(classesArgs === null || classesArgs === void 0 ? void 0 : classesArgs.reduce(function (allKeys, classes) {
    return allKeys.concat(Object.getOwnPropertyNames(classes !== null && classes !== void 0 ? classes : {}));
  }, []));
  var mergedClasses = keySet.size > 0 ? {} : undefined;
  keySet.forEach(function (key) {
    mergedClasses[key] = _clsx["default"].apply(void 0, _toConsumableArray(classesArgs === null || classesArgs === void 0 ? void 0 : classesArgs.map(function (classes) {
      return classes === null || classes === void 0 ? void 0 : classes[key];
    })));
  });
  return mergedClasses;
};

exports.mergeClasses = mergeClasses;